/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.custom.enrichment.rpc.client.SmartPropertyCitationService
 */

export const CallTranscriptCitationTypename = 'com.hubspot.custom.enrichment.models.CallTranscriptCitation';
export const CrmDataCitationBaseTypename = 'com.hubspot.custom.enrichment.models.CrmDataCitationBase';
export const WebDataCitationTypename = 'com.hubspot.custom.enrichment.models.WebDataCitation';
export const getCitationInformationRpc = {
  serviceName: 'com.hubspot.custom.enrichment.rpc.client.SmartPropertyCitationService',
  rpcName: 'getCitationInformation',
  auth: 'app',
  fingerprint: 'EOZIQgEJrQmDPhJNgMUNk3_FG_ZNyoZ6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};